import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'aqua-leave-confirm-dialog',
  templateUrl: './leave-confirm-dialog.component.html',
  styleUrls: ['./leave-confirm-dialog.component.css']
})
export class LeaveConfirmDialogComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// /opt/build/repo/src/app/dialogs/leave-confirm-dialog/leave-confirm-dialog.component.ts